import React from "react";
import styles from "./Comments.module.css";
import Avatar from "../Avatar";

import pt from "date-fns/locale/pt";
import { utcToZonedTime } from "date-fns-tz";
import { format } from "date-fns";

const CommentSingle = props => {
  function convertTimeZone(dateTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return utcToZonedTime(dateTime, timezone);
  }

  function formatDate(date, template = 1) {
    const timeZoneConvert = convertTimeZone(date);
    if (template === 1) {
      return format(timeZoneConvert, "dd 'de' MMMM 'de' yyyy  'às' HH':'mm", { locale: pt });
    } else {
      return format(timeZoneConvert, "yyyy'-'MM'-'dd' 'HH':'mm", {
        locale: pt,
      });
    }
  }

  const { index = 0, username, message, created_at, className, ...other } = props;

  return (
    <li key={index} className={`${styles.message} ${className ? className : ""}`}>
      <div className={styles.infoContainer}>
        <div>
          <div className={styles.avatar}>
            <Avatar className="mr-2" username={username || ""} />
          </div>
        </div>
        <div className={styles.msgInfo}>
          <h4>{username}:</h4>
          <p>{message}</p>
          <time className={styles.time}>{formatDate(created_at)}</time>
        </div>
      </div>
    </li>
  );
};

export default CommentSingle;
